/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Alert_TextInputs */

const en_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the level of shot change detection`)
};

const fr_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez le niveau de detection de changement de plan`)
};

const de_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Stufe der Schusswechselerkennung.`)
};

const it_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il livello di rilevamento del cambio di scatto`)
};

const ru_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите уровень обнаружения смены кадра`)
};

const es_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el nivel de detección de cambios de disparo`)
};

const zh_cn2_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择投篮变化检测级别`)
};

const ja_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットチェンジ検出のレベルを選択する`)
};

const hi_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन पहचान का स्तर चुनें`)
};

const pt_pt2_scene_change_detection_alert_text = /** @type {(inputs: Scene_Change_Detection_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o nível de detecção de mudança de tiro.`)
};

/**
* | output |
* | --- |
* | "Select the level of shot change detection" |
*
* @param {Scene_Change_Detection_Alert_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_alert_text = /** @type {((inputs?: Scene_Change_Detection_Alert_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Alert_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_alert_text(inputs)
	if (locale === "de") return de_scene_change_detection_alert_text(inputs)
	if (locale === "it") return it_scene_change_detection_alert_text(inputs)
	if (locale === "ru") return ru_scene_change_detection_alert_text(inputs)
	if (locale === "es") return es_scene_change_detection_alert_text(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_alert_text(inputs)
	if (locale === "ja") return ja_scene_change_detection_alert_text(inputs)
	if (locale === "hi") return hi_scene_change_detection_alert_text(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_alert_text(inputs)
	return en_scene_change_detection_alert_text(inputs)
});